
export default {
  name: 'UploadPhoto',
  props: {
    // 可上传图片数量
    limit: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: 'icon-upload_a_picture'
    },
    newclose: {
      // 是否使用新的删除按钮
      type: Boolean,
      default: false
    },
    isupload: {
      type: Boolean,
      default: false
    },
    maxsize: {
      // 最多上传图片
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      // 上传照片列表数据
      fileList: [],
      // 预览图片url
      // 转换base64后的数据
      picArray: [],
      // 转换为字符串后的base64数据
      pic: '',
      hideUpload: false
    }
  },
  watch: {
    picArray() {
      // 传递处理好的图片数据
      this.$emit('onPicChange', JSON.parse(JSON.stringify(this.picArray)))
    },
    fileList(oldV) {
      // 隐藏图标
      oldV.length > 4 ? (this.hideUpload = true) : (this.hideUpload = false)
      this.$emit('uploadImgList', oldV.length)
    }
  },
  methods: {
    init(arr) {
      if (arr.length == 0) return
      arr.forEach((item, index) => {
        this.fileList.push({
          name: `${index}.jpg`,
          url: item,
          imgurl: item
        })
      })
    },
    // 父组件控制清空
    emptyFileList() {
      this.$nextTick(() => {
        this.fileList = []
      })
    },
    // 获取文件信息
    getFile(file, fileList) {
      console.log(file, fileList, 41)
      // 不允许上传同
      if (!file) return
      // const filterRes = fileList.filter(f => f.name === file.name && f.size === file.size)
      // filterRes.length > 1 && fileList.pop()
      this.fileList = fileList
      this.picArray = []
      // 只能上传图
      const testFile = file.name.split('.')[1]
      const extension = testFile === 'png' || testFile === 'jpg' || testFile === 'jpeg'
      // 2MB
      const isLt2M = file.size / 1024 / 1024 < this.maxsize
      if (!extension) {
        fileList.pop()
        this.$Toast.fail({
          message: this.$v('图片格式有误'),
          icon: 'none',
          duration: 2000,
          getContainer: '#contactuslog'
        })
        return
      }
      console.log(2, isLt2M, file.size / 1024 / 1024)
      if (!isLt2M) {
        fileList.pop()
        this.$emit('uploadError', true)
        return
      }
      for (const item of fileList) {
        if (item.raw) {
          this.getBase64(item.raw).then((res) => {
            // 文件格式
            res = res.toString()?.split(',')[1]
            const ext = item.name?.split('.')[1]
            this.picArray.push({
              base64: res,
              ext
            })
            this.$emit('uploadError', false)
          })
        }
      }
      if (this.isupload && file.raw) {
        this.getBase64(file.raw).then((res) => {
          // 文件格式
          res = res.toString()?.split(',')[1]
          const ext = file.name?.split('.')[1]
          this.uploadimg(res, ext, (d) => {
            this.fileList.forEach((item) => {
              if (item.uid == file.uid) {
                item.imgurl = d
              }
            })
            this.$emit('loadbase', this.fileList)
          })
        })
      }
    },
    // 获取图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    handleRemove(file) {
      console.log(file, 42)
      const uid = file.uid
      const arr = JSON.parse(JSON.stringify(this.fileList))
      this.fileList = arr.filter((item) => item.uid != uid) || []
      this.$emit('loadbase', this.fileList)
    },
    // 删除
    handleUploadRemove(file, fileList) {
      console.log(file, 43)
      this.fileList = fileList
    },
    uploadimg(base64, extension, fn) {
      this.$api.common
        .CV3(
          {
            base64,
            uid: this.$store.state.user.userId || '',
            ext: extension
          },
          {
            Routes: 'wikifxfabulous$fileimage'
          }
        )
        .then((res) => {
          const data = res && res.wikifxfabulous && res.wikifxfabulous.fileimage
          console.log(res, 8888)
          if (data.data) fn(data.data.url)
          else {
            this.$message({
              message: data.message,
              type: 'error'
            })
          }
        })
    }
  }
}
